import * as React from "react"
import { CollectionSearch } from "./collection-search"
import { api } from "../../../lib/api/client"
import type { CollectionSearchProps, CustomSearchFn } from "./types"

export interface ContactSearchProps
  extends Omit<CollectionSearchProps, "collection" | "displayMode" | "includeFields"> {
  /** Additional filter beyond default contact filtering */
  filter?: Record<string, any>
  /** When provided, searches only contacts associated with this matter's parties */
  matterId?: string
}

/**
 * ContactSearch - Pre-configured CollectionSearch for contacts.
 *
 * Features enhanced contact display showing name, email, and phone.
 * When `matterId` is provided, searches only the matter's party contacts
 * via `GET /v1/matters/:id/party_contacts`.
 */
export function ContactSearch({
  placeholder = "Search contacts...",
  matterId,
  ...props
}: ContactSearchProps) {
  const customSearchFn = React.useMemo<CustomSearchFn | undefined>(() => {
    if (!matterId) return undefined
    return async (params) => {
      const response = await api.matters.partyContacts(matterId, {
        search: params.searchString || undefined,
      })
      return response as any
    }
  }, [matterId])

  return (
    <CollectionSearch
      {...props}
      collection="contacts"
      displayMode="contacts"
      includeFields={["email", "phone"]}
      placeholder={placeholder}
      customSearchFn={customSearchFn}
    />
  )
}
